<div class="row">
  @if (showThumbnails) {
    <div class="col-3 col-md-2">
      @if (linkType !== linkTypes.None) {
        <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
          [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
          [routerLink]="[itemPageRoute]" class="dont-break-out" tabindex="-1">

          @if (dso.allMetadata(['person.thumbnail-url']).length > 0) {
            <div class="thumbnail limit-width ng-star-inserted" style="max-width:125px;">
              <img 
                class="thumbnail-content img-fluid ng-star-inserted" 
                attr.src="{{ dso.allMetadata(['person.thumbnail-url'])[0].value }}">
            </div>
          }

          @if (dso.allMetadata(['person.thumbnail-url']).length < 1) {
            <ds-thumbnail [thumbnail]="dso?.thumbnail | async"
              [defaultImage]="'assets/images/person-placeholder.svg'"
              [alt]="'thumbnail.person.alt'"
              [placeholder]="'thumbnail.person.placeholder'">
            </ds-thumbnail>
          }
        </a>
      }
      @if (linkType === linkTypes.None) {
        <span class="dont-break-out">
          <ds-thumbnail [thumbnail]="dso?.thumbnail | async"
            [defaultImage]="'assets/images/person-placeholder.svg'"
            [alt]="'thumbnail.person.alt'"
            [placeholder]="'thumbnail.person.placeholder'">
          </ds-thumbnail>
        </span>
      }
    </div>
  }
  <div [ngClass]="showThumbnails ? 'col-9 col-md-10' : 'col-12'">
    @if (showLabel) {
      <ds-badges [object]="dso" [context]="context"></ds-badges>
    }
    <ds-truncatable [id]="dso.id">
      @if (linkType !== linkTypes.None) {
        <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
          [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
          [routerLink]="[itemPageRoute]" class="lead"
        [innerHTML]="dsoTitle || ('person.listelement.no-title' | translate)" role="link" tabindex="0"></a>
      }
      @if (linkType === linkTypes.None) {
        <span
          class="lead"
        [innerHTML]="dsoTitle || ('person.listelement.no-title' | translate)"></span>
      }
      <span class="text-muted">
        <ds-truncatable-part [id]="dso.id" [minLines]="1">
          @if (dso.allMetadata(['person.vinculo']).length > 0) {
            <span
              class="item-list-job-title">
              @for (value of allMetadataValues(['person.vinculo']); track value; let last = $last) {
                <span>
                  <span [innerHTML]="value"><span [innerHTML]="value"></span></span>
                </span>
              }
            </span>
          }
        </ds-truncatable-part>
      </span>
    </ds-truncatable>
  </div>
</div>

